export * from './camera-details.component';
